import { flashcardManager } from './flashcardManager';

export interface ImportQueueItem {
  id: string;
  total: number;
  cards: any[];
}

class FlashcardImportQueueService {
  private isProcessing = false;

  public async enqueue(cards: any[]) {
    const queue = this.getQueue();
    queue.push({
      id: Date.now().toString(),
      total: cards.length,
      cards: cards
    });
    this.saveQueue(queue);
    this.processQueue();
  }

  public getQueue(): ImportQueueItem[] {
    const data = localStorage.getItem('libritui_flashcard_import_queue');
    if (data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  private saveQueue(queue: ImportQueueItem[]) {
    localStorage.setItem('libritui_flashcard_import_queue', JSON.stringify(queue));
  }

  public async processQueue() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    try {
      let queue = this.getQueue();

      while (queue.length > 0) {
        const job = queue[0];
        
        this.emitProgress(job.total - job.cards.length, job.total);

        while (job.cards.length > 0) {
          const card = job.cards.shift();
          
          try {
             await flashcardManager.saveFlashcardsBatch([card]);
          } catch(e) {
             console.error("Queue item error", e);
          }

          // Salva progresso após cada inserção para garantir persistência
          this.saveQueue(queue);
          this.emitProgress(job.total - job.cards.length, job.total);
        }

        // Job concluído
        queue.shift();
        this.saveQueue(queue);
        
        window.dispatchEvent(new CustomEvent('importQueueComplete'));
      }
    } catch(err) {
      console.error("Queue processing error", err);
    } finally {
      this.isProcessing = false;
    }
  }

  private emitProgress(current: number, total: number) {
    window.dispatchEvent(new CustomEvent('importQueueProgress', { detail: { current, total } }));
  }
}

export const flashcardImportQueueService = new FlashcardImportQueueService();
